module.exports = __webpack_public_path__ + "img/mu.46514c80.svg";